export default __webpack_public_path__ + "static/media/phase0.4627c2ec.png";